import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  output,
} from '@angular/core';

import { AdminDictionaryCategoryBoxDataSourceService } from '../../services/admin-dictionary-category-box-data-source.service';
import { DictionaryDetailsForm } from '../../../shared/models/dictionary-details-form';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { DictionaryDetailsFormComponent } from '../../../shared/containers/dictionary-details-form/dictionary-details-form.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpErrorService } from '@web/common';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-dictionary-box-category-create',
  imports: [DictionaryDetailsFormComponent, AlertsComponent],
  templateUrl: './admin-dictionary-box-category-create.component.html',
  styleUrl: './admin-dictionary-box-category-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminDictionaryBoxCategoryCreateComponent {
  /* prettier-ignore */
  private readonly adminDictionaryDataSource = inject(AdminDictionaryCategoryBoxDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly submitSuccessEvent = output();

  private readonly destroyRef = inject(DestroyRef);

  public handleSubmitClickEvent(data: DictionaryDetailsForm): void {
    this.adminDictionaryDataSource
      .createByFormData(data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.submitSuccessEvent.emit(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
